import { render } from "./verifyEmail.vue?vue&type=template&id=33bdb770&scoped=true"
import script from "./verifyEmail.vue?vue&type=script&lang=js"
export * from "./verifyEmail.vue?vue&type=script&lang=js"

import "./verifyEmail.vue?vue&type=style&index=0&id=33bdb770&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33bdb770"]])

export default __exports__